import { ERROR_RESPONSE } from "../codeResponses/codes";
import { Toast } from "../../components/UI/toast/Toast";
import { store } from "../../Store";
import {
  AUTH_TYPES,
  CONDOMINIUM_TYPES,
  PROPERTY_TYPES,
} from "../../actions/types";

export const ACCOUNT_WITHOUT_PROPERTIES_MESSAGE =
  "Esta cuenta ya no tiene propiedades asignadas. Inicia sesión con la cuenta a la que se pasaron tus propiedades o contacta a tu administrador.";

export const isAccountWithoutProperties = (data) =>
  data?.code === ERROR_RESPONSE.ACCOUNT_WITHOUT_PROPERTIES;

export const closeSessionWithoutProperties = () => {
  if (!store.getState()?.auth?.isLogged) {
    return;
  }

  store.dispatch({ type: PROPERTY_TYPES.UNSELECT_PROPERTY });
  store.dispatch({ type: CONDOMINIUM_TYPES.UNSELECT_CONDOMINIUM });
  store.dispatch({ type: AUTH_TYPES.LOGOUT_SUCCESS });

  Toast.fire({
    type: "error",
    title: ACCOUNT_WITHOUT_PROPERTIES_MESSAGE,
  });
};
